/**
 * @desc - 買い物かごに移動
 */

$(function() {
  var element = $('#moveCart');
  $(element).show();
  $('#cartTop').on('inview', function(event, isInView, visiblePartX, visiblePartY) {
    var visible = element.is(':visible');
    if (isInView) {
      element.fadeOut('fast');
    } else{
      element.fadeIn('fast');
    }
  });
});